/** @jsx jsx */
import React from 'react'
import { jsx } from 'theme-ui'
import { css } from '@emotion/react'
import { indexOf } from 'lodash'

const colorMap = {
  dark1: 'b1',
  dark2: 'b2',
  light1: 'b8',
  light2: 'b7',
  light3: 'b6',
  white: 'b9',
}

const darkColors = ['dark1', 'dark2']

const colorFromSectionColor = (color) => {
  return colorMap[color] ? colorMap[color] : 'white'
}

export const textColorFromSectionColor = (color) => {
  return indexOf(darkColors, color) >= 0 ? 'light' : 'dark'
}

const Card = (props) => {
  const { color, children, inner, minimal, ...otherProps } = props

  const bgColor = colorFromSectionColor(color)
  const textColor = textColorFromSectionColor(color)

  return (
    <div
      sx={{
        backgroundColor: bgColor,
        color: textColor,
        borderRadius: 3,
        px: minimal ? [4, 5] : [5, 7, null, 8, inner ? 8 : 9, 9],
        py: minimal ? [4, 5] : [5, 7, null, 8, inner ? 8 : 9],
      }}
    >
      {children}
    </div>
  )
}

export default Card
